module.exports = __webpack_public_path__ + "img/Investec_Logo.6785a6f0.svg";